<template>
  <el-card shadow="never">
    <span class="fs-14 secondary-text">{{$t('customer_portal.Payment_made_on')}}<span  v-if="payment.date">{{_moment(payment.date)}}</span><span v-else  class="fs-14 secondary-text">{{$t('NA')}}</span></span><br>
    <span class="fs-14 secondary-text" v-if="payment.created_at != null">{{$t('customer_portal.Payment_created_at')}}{{_moment(payment.created_at)}}<br></span>
    <span class="fs-14 secondary-text">{{$t('customer_portal.Payment_made_by')}}</span><span v-if="payment.user!=null" class="fs-14 secondary-text">{{payment.user.first_name}} {{payment.user.last_name}}<br></span><span v-else class="fs-14 secondary-text">S.O. <br></span>
    <span class="fs-14 secondary-text">{{$t('customer_portal.Payment_amount')}}{{$n(payment.amount,'currency', currency)}}</span><br>
    <span class="fs-14 secondary-text">{{$t('customer_portal.Amount')}}{{$n(payment.invoice_payment.amount,'currency', currency)}}</span><br>
    <span class="fs-14 secondary-text">{{$t('customer_portal.Payment_method')}}<span v-if="payment.payment_type.code=='CREDIT_CARD' && payment.trx_detail!=null"> **** **** **** {{payment.trx_detail.card.lastDigits}} ({{$t('invoices.'+payment.trx_detail.card.type+'_CARD')}})</span><span v-else>{{$t('invoices.'+payment.payment_type.code)}}</span></span>
    <span class="fs-14 secondary-text" v-if="payment.payment_type.code=='CREDIT_CARD' && payment.trx_detail != null && payment.trx_detail.authCode!=null"><br>{{$t('customer_portal.Aythorization_code')}}{{payment.trx_detail.authCode}}</span>
    <div v-else>
      <span class="fs-14 secondary-text">{{$t('customer_portal.Payment_reference')}} {{payment.reference}}</span><br>
      <span class="fs-14 secondary-text">{{$t('customer_portal.Payment_description')}} {{payment.description}}</span>
    </div>
  </el-card>
</template>
<script>
import moment from 'moment-timezone'

export default {
  name: 'Unpaid-Customer-Invoices',
	props: {
    payment : Object,
    currency : {
      type : String,
      default : 'CAD'
    }
	},
  data() {
    return {

    };
  },
	methods: {
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
  },
  components : {},
	computed: {	}
}
</script>
<style lang="scss" scoped>


</style>
